import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import Filter from "../../components/elements/Filter";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import Placeholder from "../../components/Placeholder/PlaceholderText";
import Settings from "../../assets/images/icons/icon_settings_header.svg";

import { Table } from "./styles";
import { getEconomicGroup, getEconomicGroups } from "../../store/middleware";

function EconomicGroup() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [listEconomicGroup, setListEconomicGroup] = useState([]);
  const [filter, setFilter] = useState({
    name: "",
    code: "",
    active: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter((state) => ({ ...state, [name]: value }));
  };

  const getData = () => {
    dispatch(getEconomicGroups()).then((res) => setListEconomicGroup(res));
  };

  const clearFilters = () => {
    setFilter({
      name: "",
      code: "",
      active: "",
      description: "",
    });
    applyFilters({
      name: "",
      code: "",
      active: "",
      description: "",
    });
  };

  const applyFilters = (filter) => {
    dispatch(getEconomicGroup(filter)).then((res) => setListEconomicGroup(res));
  };

  const filters = [
    {
      type: "text",
      placeholder: "Name",
      name: "name",
      label: "Group Name",
      value: filter.name,

      width: 100,
    },
    {
      type: "text",
      placeholder: "Code",
      name: "code",
      label: "Code",
      value: filter.code,
    },
    {
      type: "select",
      placeholder: "Select",
      name: "active",
      label: "Status",
      value: filter.active,
      options: [
        { id: 1, name: "Active" },
        { id: 0, name: "Inactive" },
      ],
    },
  ];

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          title="Economic Group"
          icon={<img src={Settings} alt="Settings" />}
          typeIcon="custom"
          rightButton={
            <button className="buttonRight" onClick={() => navigate("/economic-group/new")}>
              <i className="fa fa-plus" aria-hidden="true" />
              Add new Group
            </button>
          }
          t={t}
        />

        <div className="content">
          <Filter
            filters={filters}
            clear={clearFilters}
            inputChange={handleChange}
            submit={() => applyFilters(filter)}
          />
          {listEconomicGroup?.length > 0 ? (
            <Table>
              <div className="bigBoxTableEconomic">
                <table>
                  <tbody>
                    <tr>
                      <th>Code</th>
                      <th>{t("NAME")}</th>
                      <th>{t("DESCRIPTION")}</th>
                      <th>{t("STATUS")}</th>
                    </tr>

                    {listEconomicGroup.map((list) => (
                      <tr key={list.code}>
                        <td>{list.code}</td>
                        <td>{list.name}</td>
                        <td>{list.description}</td>
                        <td>
                          <span style={{ color: list.active ? "#0ED572" : "#FF5666" }}>
                            {list.active ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td>
                          <Link to={`/economic-group/${list.id}`} state={{ data: list }}>
                            <button>
                              View <i className="fa fa-angle-right" aria-hidden="true"></i>
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Table>
          ) : (
            <Placeholder label="No results" />
          )}
        </div>
      </section>
    </div>
  );
}

export default EconomicGroup;
